import React, { useState } from "react";
import { useHistory } from "react-router";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import Avatar from "@mui/material/Avatar";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";

const useStyles = makeStyles({
  icon: {
    width: 25,
    height: 25,
    paddingLeft: 10,
    marginRight: 30,
    maxWidth: "30px",
    maxHeight: "30px",
    minWidth: "30px",
    minHeight: "30px",
  },
  itemButton: {
    display: "flex",
    alignItems: "center",
    boxShadow: "none",
    border: "none",
    width: "100%",
    textAlign: "left",
    color: "#FFFFFF",
    padding: "10px 15px",
    backgroundColor: "#004990",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#013669",
    },
    "&:focus": {
      backgroundColor: "#013669",
    },
  },
  subItemButton: {
    display: "flex",
    alignItems: "center",
    boxShadow: "none",
    borderTop: "none",
    borderLeft: "none",
    borderRight: "none",
    borderBottom: "1px solid #FFF",
    width: "90%",
    textAlign: "left",
    color: "#FFFFFF",
    padding: "10px 15px",
    backgroundColor: "#004990",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#013669",
    },
    "&:focus": {
      backgroundColor: "#013669",
    },
  },
  avatarItem: {
    marginRight: 20,
  },
});

export default function ListItemDrawer({
  text,
  icon,
  avatar,
  goTo,
  menu,
  children,
  isSub,
  onClick,
  isDisabled
}) {
  const history = useHistory();
  const classes = useStyles();
  const [subOpen, setSubOpen] = useState(false);

  const handleMenuClick = () => {
    setSubOpen(!subOpen);
  };

  return avatar ? (
    <>
      <button disabled={isDisabled} className={classes.itemButton} onClick={() => history.push(goTo)}>
        <div className={classes.avatarItem}>
          <Avatar alt={text} src={icon} />
        </div>
        {text}
      </button>
    </>
  ) : (
    <>
      {menu ? (
        <>
          <button disabled={isDisabled} className={classes.itemButton} onClick={handleMenuClick}>
            <img className={classes.icon} alt="icon" src={icon} />
            {text}
            {subOpen ? (
              <ArrowDropUpIcon sx={{ ml: 1 }} />
            ) : (
              <ArrowDropDownIcon sx={{ ml: 1 }} />
            )}
          </button>

          <Collapse in={subOpen} timeout="auto" unmountOnExit>
            <List component="div" sx={{ pl: 9 }} disablePadding>
              {children}
            </List>
          </Collapse>
        </>
      ) : isSub ? (
        <>
          <button
            disabled={isDisabled}
            className={classes.subItemButton}
            onClick={() => history.push(goTo)}
          >
            {text}
          </button>
        </>
      ) : (
        <>
          <button disabled={isDisabled} className={classes.itemButton} onClick={onClick}>
            <img className={classes.icon} alt="icon" src={icon} />
            {text}
          </button>
        </>
      )}
    </>
  );
}

ListItemDrawer.defaultProps = {
  avatar: false,
  onClick: () => null,
  menu: false,
  icon: "",
  children: null,
  isSub: false,
  goTo: "",
  isDisabled: false,
};

ListItemDrawer.propTypes = {
  avatar: PropTypes.bool,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  menu: PropTypes.bool,
  text: PropTypes.string.isRequired,
  goTo: PropTypes.string,
  isSub: PropTypes.bool,
  isDisabled: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.object]),
};
